module.exports = __webpack_public_path__ + "img/hiv-sure-check.dd9e5406.png";